import React from 'react'
import './index.css'
import Layout from '../../brands/components/Layout'
import { Tabs, Tab } from 'react-bootstrap'
import NotificationTable from '../components/NotificationTable'

const Notification: React.FC = () => {
    const [activeTab, setActiveTab] = React.useState('all')

    return (
        <div>
            <Layout>
                <div className="mb-3">
                    <h4>Notification</h4>
                </div>
                <Tabs
                    activeKey={activeTab}
                    onSelect={(k: any) => setActiveTab(k)}
                    defaultActiveKey="all"
                    id="uncontrolled-tab-example"
                    className="mb-3 mt-4 custom-tabs"
                >
                    <Tab eventKey="all" title="All">
                        <NotificationTable type={'all'} activeTab={activeTab} />
                    </Tab>
                    <Tab eventKey="unread" title="Unread">
                        <NotificationTable
                            type={'unread'}
                            activeTab={activeTab}
                        />
                    </Tab>
                </Tabs>
            </Layout>
        </div>
    )
}

export default Notification
